// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.Vehicles__View[data-v-14d2bc6c] {\r\n  height: 100%;\n}\r\n", ""]);
// Exports
module.exports = exports;
